import { render, staticRenderFns } from "./packageDialog.vue?vue&type=template&id=c72e7476&"
import script from "./packageDialog.vue?vue&type=script&lang=js&"
export * from "./packageDialog.vue?vue&type=script&lang=js&"
import style0 from "./packageDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/toutiao/packageDialog.vue
// module id = null
// module chunks = 